import { Resume } from '@sr/types';
import { useThemeUI } from 'theme-ui';
import { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import Divider from '../common/Divider';
import { Box, Image, ResumeHeading, Text, WebsiteLink } from '../common/ui';

const Header = ({ resume }: { resume: Resume }) => {
  const theme = useThemeUI().theme as ResumeTheme;
  const calcSize = getCalcSize(theme.baseSize);
  const {
    city,
    email,
    firstName,
    lastName,
    phone,
    state,
    summary,
    title,
    website,
    website2,
  } = resume.about;
  return (
    <Box
      className="pdf-resume-header"
      variant="headerContainer"
      as="header"
      sx={{
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          <ResumeHeading>
            {firstName} {lastName}
          </ResumeHeading>
          <Text mb={calcSize(0.5)}>{title}</Text>
          <Text mb={calcSize(0.5)} color="secondaryText">
            <Divider divider=" | " breakBelow={400}>
              {(city || state) && (
                <Divider divider=", ">
                  {city}
                  {state}
                </Divider>
              )}
              {website && <WebsiteLink url={website} />}
              {website2 && <WebsiteLink url={website2} />}
              {email}
              {phone}
            </Divider>
          </Text>
        </Box>

        {resume.profilePhotoUrl && (
          <Image
            src={resume.profilePhotoUrl}
            width={130}
            height={130}
            sx={{
              borderRadius: 999,
              height: 130,
              width: 130,
              objectFit: 'cover',
            }}
          />
        )}
      </Box>
      <Text
        sx={{
          fontSize: 3,
          mb: calcSize(0.4375),
          mt: calcSize(1.25),
          fontStyle: 'italic',
        }}
        color="secondaryText"
      >
        {summary}
      </Text>
    </Box>
  );
};

export default Header;
